import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ImageGallery.css';

const ImageGallery = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // État pour gérer l'ouverture/fermeture du bandeau
  const [isOpen, setIsOpen] = useState(false);
  // État pour la modale (image en grand)
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const initFetch = async () => {
      try {
        setLoading(true);
        await fetchImages();
      } finally {
        setLoading(false);
      }
    };
    initFetch();

    const interval = setInterval(fetchImages, 5000);
    return () => clearInterval(interval);
  }, []);

  const fetchImages = async () => {
    try {
      // Background fetch - do not trigger loading state
      const response = await axios.get(`${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/api/images/`);
      setImages(response.data);
      setError(null);
    } catch (err) {
      console.error('Error polling images:', err);
      // Don't set global error to avoid blocking UI on transient poll failures
    }
  };

  if (loading) {
    return (
      <div className="gallery-container">
        <div className="loading">CHARGEMENT DES ARCHIVES...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="gallery-container">
        <div className="error">{error}</div>
      </div>
    );
  }

  // Séparer les images uploadées et générées
  const uploadedImages = images.filter(img => img.original_image_url && !img.generated_image_url);
  const generatedImages = images.filter(img => img.generated_image_url);

  const toggleGallery = () => {
    setIsOpen(!isOpen);
  };

  const handleImageClick = (image) => {
    // On reconstruit la liste visuelle pour trouver l'index
    const visualList = [...generatedImages, ...uploadedImages];
    const index = visualList.findIndex(img => img.id === image.id);

    // On privilégie l'image générée, sinon l'originale
    const imageUrl = image.generated_image_url || image.original_image_url;
    setSelectedImage({ url: imageUrl, prompt: image.prompt, index: index });
  };

  const handleNext = () => {
    const visualList = [...generatedImages, ...uploadedImages];
    if (selectedImage && selectedImage.index < visualList.length - 1) {
      const nextIndex = selectedImage.index + 1;
      const nextImage = visualList[nextIndex];
      const imageUrl = nextImage.generated_image_url || nextImage.original_image_url;
      setSelectedImage({ url: imageUrl, prompt: nextImage.prompt, index: nextIndex });
    }
  };

  const handlePrev = () => {
    const visualList = [...generatedImages, ...uploadedImages];
    if (selectedImage && selectedImage.index > 0) {
      const prevIndex = selectedImage.index - 1;
      const prevImage = visualList[prevIndex];
      const imageUrl = prevImage.generated_image_url || prevImage.original_image_url;
      setSelectedImage({ url: imageUrl, prompt: prevImage.prompt, index: prevIndex });
    }
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <>
      <div className={`gallery-container ${!isOpen ? 'closed' : ''}`}>
        {/* Bouton Toggle Central (Onglet) */}
        <button className="gallery-toggle-tab" onClick={toggleGallery}>
          <span className="toggle-text">GALERIE</span>
        </button>

        <div className="gallery-scroll-content">
          {images.length === 0 ? (
            <div className="empty-gallery">
              <p>AUCUNE DONNÉE DANS L'HISTORIQUE</p>
            </div>
          ) : (
            <>
              {/* Bandeau des images générées */}
              {generatedImages.length > 0 && (
                <div className="gallery-section">
                  <h3 className="gallery-section-title">IMAGES GÉNÉRÉES</h3>
                  <div className="gallery-grid">
                    {generatedImages.map((image) => (
                      <div key={image.id} className="gallery-item" onClick={() => handleImageClick(image)}>
                        <div className="gallery-image-wrapper">
                          <img
                            src={image.generated_image_url}
                            alt={`Generated ${image.id}`}
                            className="gallery-image"
                          />
                        </div>
                        <div className="gallery-info">
                          <p className="gallery-prompt" title={image.prompt}>
                            {image.prompt || 'SANS TITRE'}
                          </p>
                          <p className="gallery-date">
                            {new Date(image.created_at).toLocaleDateString('fr-FR')}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}


            </>
          )}
        </div>
      </div>

      {/* MODALE IMAGE EN GRAND */}
      {/* MODALE IMAGE EN GRAND */}
      {selectedImage && (
        <div className="image-modal-overlay" onClick={closeModal}>
          <button className="modal-close-btn" onClick={closeModal}>×</button>

          {/* Bouton Précédent */}
          {selectedImage.index > 0 && (
            <button
              className="modal-nav-btn prev"
              onClick={(e) => { e.stopPropagation(); handlePrev(); }}
            >
              &#10094;
            </button>
          )}

          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage.url} alt="Full view" className="modal-image" onClick={closeModal} />
            {selectedImage.prompt && <p className="modal-caption">{selectedImage.prompt}</p>}
          </div>

          {/* Bouton Suivant */}
          {selectedImage.index < (generatedImages.length + uploadedImages.length) - 1 && (
            <button
              className="modal-nav-btn next"
              onClick={(e) => { e.stopPropagation(); handleNext(); }}
            >
              &#10095;
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default ImageGallery;